import React, { useMemo } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { useHistory } from 'react-router';
import PropTypes from 'prop-types';

import { setupStripe } from 'utils/stripe';
import IndexPage from 'components/Common/IndexPage';

import CheckoutForm from './CheckoutForm';

const getStripeConfig = () => {
  const options = {
    fonts: [
      {
        cssSrc:
          'https://fonts.googleapis.com/css2?family=Mulish:ital,wght@0,200;0,300;0,400;0,600;0,700;1,400;1,800&display=swap',
      },
    ],
    // This is the only way to customize the Stripe's Payment element
    appearance: {
      theme: 'none',

      rules: {
        '.Input': {
          border: 'solid 1px rgb(98, 114, 147)',
          fontFamily: 'Mulish',
          fontSize: '14px',
        },
        '.Input::placeholder': {
          color: 'transparent',
        },
        '.Label': {
          fontFamily: 'Mulish',
          fontSize: '14px',
          color: 'rgb(30, 30, 30)',
          fontWeight: 600,
        },
      },
    },
  };

  return options;
};

export const Checkout = () => {
  const history = useHistory();

  const stripePromise = useMemo(() => setupStripe());

  const handleBackAction = () => history.push(`/settings/subscription`);

  return (
    <Elements stripe={stripePromise} options={getStripeConfig()}>
      <IndexPage title="Upgrade Plan" onClickBack={handleBackAction}>
        <CheckoutForm />
      </IndexPage>
    </Elements>
  );
};

Checkout.propTypes = {
  clientSecret: PropTypes.string,
};

export default Checkout;
